// Mock data for Ventes Suite
// This will be replaced with actual API calls

export const mockNotes = [
  {
    id: '1',
    title: 'Welcome to Ventes Suite',
    content: 'Your productivity hub for managing prompts, notes, and reminders.',
    createdAt: new Date('2025-01-05'),
    isPinned: true,
    color: '#FFE5B4'
  },
  {
    id: '2',
    title: 'Q1 Sales Strategy',
    content: 'Focus on enterprise clients and expand into European markets.',
    createdAt: new Date('2025-01-06'),
    isPinned: false,
    color: '#E5F3FF'
  },
  {
    id: '3',
    title: 'Meeting Notes',
    content: 'Product roadmap discussion - prioritize AI features.',
    createdAt: new Date('2025-01-07'),
    isPinned: false,
    color: '#FFE5F0'
  }
];

export const mockReminders = [
  {
    id: '1',
    title: 'Follow up with client',
    completed: false,
    dueDate: new Date('2025-01-10'),
    priority: 'high'
  },
  {
    id: '2',
    title: 'Review quarterly reports',
    completed: false,
    dueDate: new Date('2025-01-12'),
    priority: 'medium'
  },
  {
    id: '3',
    title: 'Team standup meeting',
    completed: true,
    dueDate: new Date('2025-01-08'),
    priority: 'low'
  },
  {
    id: '4',
    title: 'Update documentation',
    completed: false,
    dueDate: new Date('2025-01-15'),
    priority: 'medium'
  }
];

export const mockCalendarEvents = [
  {
    id: '1',
    title: 'Sales Team Meeting',
    date: new Date('2025-01-10T10:00:00'),
    duration: 60,
    color: '#3b82f6'
  },
  {
    id: '2',
    title: 'Client Presentation',
    date: new Date('2025-01-12T14:00:00'),
    duration: 90,
    color: '#10b981'
  },
  {
    id: '3',
    title: 'Product Demo',
    date: new Date('2025-01-15T11:00:00'),
    duration: 45,
    color: '#8b5cf6'
  }
];

export const mockGallery = [
  {
    id: '1',
    prompt: 'Modern minimalist office workspace with natural lighting',
    imageUrl: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
    createdAt: new Date('2025-01-08T14:30:00'),
    size: '1024x1024',
    likes: 42
  },
  {
    id: '2',
    prompt: 'Abstract digital art with vibrant colors and geometric shapes',
    imageUrl: 'https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=800&q=80',
    createdAt: new Date('2025-01-08T12:15:00'),
    size: '1024x1024',
    likes: 38
  },
  {
    id: '3',
    prompt: 'Futuristic city skyline at sunset with flying vehicles',
    imageUrl: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=800&q=80',
    createdAt: new Date('2025-01-07T16:45:00'),
    size: '1920x1080',
    likes: 56
  },
  {
    id: '4',
    prompt: 'Serene mountain landscape with crystal clear lake reflection',
    imageUrl: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
    createdAt: new Date('2025-01-07T10:20:00'),
    size: '1024x1024',
    likes: 67
  },
  {
    id: '5',
    prompt: 'Professional product photography of luxury watch on marble',
    imageUrl: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800&q=80',
    createdAt: new Date('2025-01-06T18:30:00'),
    size: '1024x1024',
    likes: 45
  },
  {
    id: '6',
    prompt: 'Cozy coffee shop interior with warm ambient lighting',
    imageUrl: 'https://images.unsplash.com/photo-1445116572660-236099ec97a0?w=800&q=80',
    createdAt: new Date('2025-01-06T09:15:00'),
    size: '1024x1024',
    likes: 51
  },
  {
    id: '7',
    prompt: 'Vibrant street art mural with bold colors and typography',
    imageUrl: 'https://images.unsplash.com/photo-1499781350541-7783f6c6a0c8?w=800&q=80',
    createdAt: new Date('2025-01-05T15:45:00'),
    size: '1920x1080',
    likes: 73
  },
  {
    id: '8',
    prompt: 'Elegant fashion portrait with dramatic studio lighting',
    imageUrl: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&q=80',
    createdAt: new Date('2025-01-05T11:00:00'),
    size: '1024x1024',
    likes: 89
  }
];

export const mockMail = [
  {
    id: '1',
    from: 'john.doe@example.com',
    subject: 'Q4 Sales Report',
    preview: 'Please find attached the quarterly sales report...',
    date: new Date('2025-01-08T09:30:00'),
    isRead: false,
    isStarred: true
  },
  {
    id: '2',
    from: 'sarah.johnson@client.com',
    subject: 'Re: Product Demo Request',
    preview: 'Thank you for the demo. We are interested in...',
    date: new Date('2025-01-07T14:20:00'),
    isRead: true,
    isStarred: false
  },
  {
    id: '3',
    from: 'team@ventessuite.com',
    subject: 'Welcome to Ventes Suite!',
    preview: 'Get started with your new productivity hub...',
    date: new Date('2025-01-06T11:00:00'),
    isRead: true,
    isStarred: false
  }
];

export const mockDrive = [
  {
    id: '1',
    name: 'Sales Presentation Q1.pptx',
    type: 'presentation',
    size: '4.2 MB',
    modifiedAt: new Date('2025-01-07'),
    sharedWith: ['team@ventessuite.com']
  },
  {
    id: '2',
    name: 'Client Contracts',
    type: 'folder',
    size: '24 items',
    modifiedAt: new Date('2025-01-06'),
    sharedWith: []
  },
  {
    id: '3',
    name: 'Marketing Assets.zip',
    type: 'archive',
    size: '156 MB',
    modifiedAt: new Date('2025-01-05'),
    sharedWith: ['marketing@ventessuite.com']
  }
];

export const mockApps = [
  {
    id: '1',
    name: 'OpenAI GPT-4',
    category: 'AI Assistant',
    description: 'Generate text, analyze content, and automate workflows',
    icon: '🤖',
    color: '#10a37f',
    status: 'connected',
    lastSync: new Date('2025-01-08T14:30:00'),
    usageCount: 156,
    isActive: true
  },
  {
    id: '2',
    name: 'DALL-E 3',
    category: 'Image Generation',
    description: 'Create stunning AI-generated images from text prompts',
    icon: '🎨',
    color: '#FF6B6B',
    status: 'connected',
    lastSync: new Date('2025-01-08T12:15:00'),
    usageCount: 89,
    isActive: true
  },
  {
    id: '3',
    name: 'Midjourney',
    category: 'Image Generation',
    description: 'Advanced AI art generation with unique styles',
    icon: '✨',
    color: '#8B5CF6',
    status: 'connected',
    lastSync: new Date('2025-01-08T10:45:00'),
    usageCount: 67,
    isActive: true
  },
  {
    id: '4',
    name: 'Stripe',
    category: 'Payments',
    description: 'Process payments and manage subscriptions',
    icon: '💳',
    color: '#635BFF',
    status: 'connected',
    lastSync: new Date('2025-01-08T09:20:00'),
    usageCount: 34,
    isActive: true
  },
  {
    id: '5',
    name: 'SendGrid',
    category: 'Email Marketing',
    description: 'Send transactional and marketing emails',
    icon: '📧',
    color: '#1A82E2',
    status: 'inactive',
    lastSync: new Date('2025-01-05T18:00:00'),
    usageCount: 12,
    isActive: false
  },
  {
    id: '6',
    name: 'Google Drive',
    category: 'Storage',
    description: 'Sync and backup files to Google Drive',
    icon: '📁',
    color: '#4285F4',
    status: 'error',
    lastSync: new Date('2025-01-07T16:30:00'),
    usageCount: 45,
    isActive: false,
    errorMessage: 'Authentication expired'
  },
  {
    id: '7',
    name: 'Slack',
    category: 'Communication',
    description: 'Send notifications and updates to Slack channels',
    icon: '💬',
    color: '#4A154B',
    status: 'connected',
    lastSync: new Date('2025-01-08T13:00:00'),
    usageCount: 203,
    isActive: true
  },
  {
    id: '8',
    name: 'Zapier',
    category: 'Automation',
    description: 'Connect with 5000+ apps and automate workflows',
    icon: '⚡',
    color: '#FF4F00',
    status: 'connected',
    lastSync: new Date('2025-01-08T11:30:00'),
    usageCount: 78,
    isActive: true
  }
];

export const mockUser = {
  name: 'Demo User',
  email: 'demo@ventessuite.com',
  storage: {
    used: 28.5,
    total: 50,
    unit: 'GB'
  }
};